import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const AddressBookIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M18 4a1 1 0 0 1 1 1v1h2v3h-2v1h2v3h-2v1h2v3h-2v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM7 19h10V6H7z"
    />
  </BaseIcon>
)
